import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './ChairmanMessage.css';

gsap.registerPlugin(ScrollTrigger);

const ChairmanMessage = () => {
    const textRef = useRef(null);

    useEffect(() => {
        const textElements = textRef.current.querySelectorAll('.chairman-fade-text');

        gsap.fromTo(
            textElements,
            { opacity: 0 },
            {
                opacity: 1,
                duration: 0.7,
                ease: 'power2.out',
                stagger: 0.2, // Small stagger for fast sequence
                scrollTrigger: {
                    trigger: textRef.current,
                    start: 'top 80%',
                    end: 'top 20%',
                    toggleActions: 'play none none reset',
                },
            }
        );
    }, []);

    return (
        <div className="chairman-message-container">
            <div className="chairman-image">
                <img
                    src="https://res.cloudinary.com/dd8cg94ku/image/upload/v1739812250/1_kzca86.svg" /* Replace with actual image URL */
                    alt="Chairman"
                    className="chairman-photo"
                />
            </div>
            <div className="chairman-text" ref={textRef}>
                <h2 className="chairman-heading chairman-fade-text">The Golden Palace</h2>
                <p className="chairman-message-paragraph chairman-fade-text">
                "Celebrate life's special moments in our grand banquet hall, equipped to
                host weddings, conferences, and events. With state-of-the-art facilities,
                water we ensure every occasion is extraordinary." <br/>
                "At The Golden Palace, leisure and relaxation are our priorities. Discover a
                range of recreational activities to make your stay memorable."
                </p>
                <p className="chairman-message-paragraph chairman-fade-text">
                    
                </p>
            </div>
        </div>
    );
};

export default ChairmanMessage;
